import { ToastQueue } from '@react-stately/toast';
import type { ToastData } from './toast-component';

let globalToastQueue: ToastQueue<ToastData> | null = null;

export function getGlobalToastQueue(): ToastQueue<ToastData> {
  if (!globalToastQueue) {
    globalToastQueue = new ToastQueue({
      maxVisibleToasts: 3,
    });
  }

  return globalToastQueue;
}

// Empties the global queue without firing toasts' onClose handlers.
// Used to reset toast state between tests (Ember, vitest, and Playwright CT).
export function clearToastQueue(): void {
  getGlobalToastQueue().clear();
}
